import { createSelector } from "reselect";

const getReducer = ({ bookingSession }) => bookingSession.contact;

export const isShowing = createSelector([getReducer], ({ isShowing }) => isShowing);
